<template>
    <div class="block-editor google-drive-download-file">
        <section>
            <div class="title">Channel ID</div>
            <TiptapEditor placeholder="Google Drive Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>Dosyanın indirileceği Google Drive kanal ID'si</small>
        </section>
        <section>
            <div class="title">File ID</div>
            <TiptapEditor placeholder="Google Drive File ID" :show-attributes="true" v-model="clone.fileId" automation-mode />
            <small>İndirilecek dosyanın Google Drive ID'si</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleDriveDownloadFile",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                fileId: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-drive-download-file {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
